<template>
    <img :src="require('@/assets/postitused/postitus1/header.png')" alt="Headeri pilt" height="300">
    <div class="columnLayout3">
        <div></div> <!-- Column 1-->
        <div class="mainContent"> <!-- Column 2-->
            <div></div> <!-- Inner Column 1-->
            <div><!-- Inner Column 2-->
                <h1>KUIDAS KEHAOSADE ABIL POENIMEKIRJA MEELDE JÄTTA?</h1>
                <p>Kas oled kunagi sattunud olukorda, mil poest koju jõudnuna oled avastanud, et ei ostnud seda ühte asja, 
                    mille pärast sinna poodi üleüldse mindud sai? Eks meil kõigil. Kui aga tunned, et sul tuleb seda ette 
                    ikka liiga tihti ning poenimekirja koostamise harjumuse juurutamine pole senini õnnestunud, siis järgnevalt 
                    sulle üks põnev lahendus.
                    <br>
                    <span class="erilineTekst">VAJA LÄHEB:</span> meeldejätjat, poenimekirja ja fantaasiat
                </p>

                <div class="columnLayout2">
                    <div> <!-- Inner Inner Column 1-->
                        <h1>1. VALI VÄLJA KEHAOSAD</h1>
                        <p class="pildiKõrvalTekst">
                            Vaja läheb nii palju kehaosasid, kui palju on nimekirjas asju (näiteks 10). Et teekonda oleks kergem
                             meelde jätta, oleks mõistlik alustada loendamist kõige alt ja lõpetada kõige üleval (või vastupidi).
                             <br>
                             <span class="erilineTekst">ÜKS VÕIMALIK TEEKOND:</span> tallaalune, põlved, tagumik, kõht, rinnad, kõri, suu, nina, kõrvad, pealagi.
                        </p>
                    </div>
                    <div> <!-- Inner Inner Column 2-->
                        <img :src="require('@/assets/postitused/postitus1/pilt1.png')" alt="Pilt 1">
                        <p class="pildiAluneTekst">
                            Kehaosade valikuvõimalused
                        </p>
                    </div>
                </div>
                <div class="columnLayout2">
                    <div> <!-- Inner Inner Column 1-->
                        <img :src="require('@/assets/postitused/postitus1/pilt2.png')" alt="Pilt 2">
                        <p class="pildiAluneTekst">
                            Näide mu 7 aastase venna seoste fantaasiast
                        </p>
                    </div>
                    <div> <!-- Inner Inner Column 2-->
                        <h1>2. SEOSTA IGA ASI VASTAVA KEHAOSAGA</h1>
                        <p class="pildiKõrvalTekst">
                            See on nüüd see osa, kus mängu tuleb fantaasia. Ülesandeks on luua mälu jaoks meeldejääv pilt sellest, kuidas sa asetad 
                            eseme listist ühele kehaosadest. <span class="erilineTekst">Soovitus:</span> ära lihtsalt aseta, vaid purusta, topi, keera, määri, lögasta.
                             <span class="erilineTekst">Mida jõledam, rõvedam ja detailsem kujutluspilt, seda meeldejäävam ja seega tõhusam. </span>
                            <br>
                            <span class="erilineTekst">NÄIDE:</span> Litsud <span class="erilineTekst">jalgadega viinamarju</span> puruks, su jalad värvuvad punaseks ja talla all on 
                            ligane tunne. Lööd endale <span class="erilineTekst"> muna otsaette</span> puruks nii, et selle sisu voolab mööda su nägu alla. Näed, 
                            kuidas su <span class="erilineTekst">põlvedest</span> paistavad <span class="erilineTekst"> porgandi</span> ja saad need iga hetk välja tõmmata.
                        </p>
                    </div>
                </div>
                <div class="columnLayout2">
                    <div> <!-- Inner Inner Column 1-->
                        <h1>3. KORDA SEOSEID</h1>
                        <p class="pildiKõrvalTekst">
                            Selleks, et midagi pikaajaliselt mäletada, on vaja korrata ja soovitatavalt pikenevate ajavahemike tagant, sest nii 
                            pikendad unustamiskõverat. Selle efekti saavutamiseks tuleks väljamõeldud lugu mõttes mitu korda läbi käia. See annab 
                            võimaluse ka kontrollida, kas loodud seosed olid meeldejäävad või tuleks midagi kuskil muuta.
                        </p>
                    </div>
                    <div> <!-- Inner Inner Column 2-->
                        <img :src="require('@/assets/postitused/postitus1/pilt3.png')" alt="Pilt 3">
                        <p class="pildiAluneTekst">
                            Seoseid saab korrata iga tegevuse keskel
                        </p>
                    </div>
                </div>
                <div class="columnLayout2">
                    <div> <!-- Inner Inner Column 1-->
                        <img :src="require('@/assets/postitused/postitus1/pilt4.png')" alt="Pilt 4">
                        <p class="pildiAluneTekst">
                            Õnnelik meeldejätja oma 10/10st käruga
                        </p>
                    </div>
                    <div> <!-- Inner Inner Column 2-->
                        <h1>4. MINE POODI</h1>
                        <p class="pildiKõrvalTekst">
                            Nüüd, kui tunned end selle loo jutustamises kindlalt, on aeg minna poodi ja kõik vajalik endale selle loo abil korvi laduda.
                            <br>
                            <span class="erilineTekst">INIMKATSE TULEMUS:</span> Viisin sama inimkatse läbi oma 7aastase vennaga, kelle listis oli 10 asja. Ta suutis 
                            iseseisvalt poest üles leida kõik asjad. Väike kõhklus tekkis tal põlvede juures (jättis põlved kogemata vahele), kuid 
                            suunava küsimuse abil mõistis ta oma viga ning edasi läks kõik ludinal. Siin video sellest inimkatsest: <a class="link" href="https://www.instagram.com/p/Cvciz4WATKP/">https://www.instagram.com/p/Cvciz4WATKP/</a>
                        </p>
                    </div>
                </div>
                <h1 >Proovi ka sina järele ja anna teada, kuidas läks!</h1>
                <br>
            </div>
            <div></div> <!-- Inner Column 3-->
        </div>
        <div></div> <!-- Column 3-->

    </div>
</template>
<script>

</script>

<style scoped>

.columnLayout3{
    display: grid;
    grid-template-columns: 0.5fr 10fr 0.5fr;
    grid-template-rows: auto;
    margin-bottom: 5ch;
}

.columnLayout2{
    display: grid;
    grid-template-columns: 50% 50%;
}

.columnLayout2 img{
    width: 100%;
    max-width: 400px;
    height: auto;
    border-radius: 25px;
}

.mainContent{
    display: grid;
    grid-template-columns: 1fr 10fr 1fr;
    grid-template-rows: auto;
    background-color: rgb(0, 0, 0, 0.7);
    
}

h1{
    font-size: 40px;
    text-align: center;
}

p{
    font-size: 20px;
    text-align: justify;
    padding: 20px;
    margin-left: 10ch;
    margin-right: 10ch;
    color: white;
}

.erilineTekst{
    color: #55E0E5;
    font-size: 19px;
    font-weight: bold;
}

.pildiAluneTekst{
    font-size: 15px;
    text-align: center;
    color: #FFFFFFA1;
    font-size: 20px;
}

.pildiKõrvalTekst{
    letter-spacing: 0.8px;
}

.link{
    color: #55E0E5;
    text-decoration: none;
    font-size: 20px;
    font-weight: bold;

}

</style>